<div class="col-md-12 mb-30">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <h5 class="card-title border-0 pb-0">Payslip</h5>
      <br />
      <br />

      <button (click)="onBack()" *ngIf="!Procssing" type="button" class="btn btn-warning"><i
          class="fa fa-mail-reply"></i> Back </button>

      <br />

      <table class="mb-0 table table-bordered table-3 text-center table-striped" *ngIf="!Procssing">
        <tr>
          <th colspan="2">Personnel Code: {{DataList_Salary['code']}} </th>
          <th colspan="2">Month: {{innerMonth}} </th>
          <th colspan="2">Year: {{innerYear}} </th>
        </tr>

        <tr>
          <th colspan="2">Full Name: {{DataList_Salary['fullname']}} </th>
          <th colspan="2">Father Name: {{DataList_Salary['fathername']}} </th>
          <th colspan="2">Organizational Position: {{DataList_Salary['semat']}} </th>
        </tr>

        <tr>
          <th style="background-color: rgb(181 184 187)" colspan="2">Base Information</th>
          <th style="background-color: rgb(181 184 187)" colspan="2">Payments</th>
          <th style="background-color: rgb(181 184 187)" colspan="2">Deductions</th>
        </tr>

        <tr>
          <td>Base Salary</td>
          <td>{{DataList_Salary['salaryRecord']['payeh']|number}}</td>

          <td>Base Salary</td>
          <td>{{DataList_Salary['payeh']|number}}</td>

          <td>Employee Insurance Contribution</td>
          <td>{{DataList_Salary['bimehKargar']|number}}</td>
        </tr>

        <tr>
          <td>Seniority Base</td>
          <td>{{DataList_Salary['sanavatPayeh']|number}}</td>

          <td>Seniority Base</td>
          <td>{{DataList_Salary['sanavat']|number}}</td>

          <td>Tax</td>
          <td>{{DataList_Salary['maliatPay']|number}}</td>
        </tr>

        <tr>
          <td>Work Experience (Years)</td>
          <td>{{DataList_Salary['year']|number}}</td>

          <td>Housing Allowance</td>
          <td>{{DataList_Salary['salaryRecord']['maskan']|number}}</td>

          <td>Loan/Advance Installment</td>
          <td></td>
        </tr>

        <tr>
          <td>Days Worked</td>
          <td>{{DataList_Salary['day']|number}}</td>

          <td>Marital Allowance</td>
          <td>{{DataList_Salary['salaryRecord']['tahahol']|number}}</td>

          <td>Supplementary Insurance</td>
          <td></td>
        </tr>

        <tr>
          <td>Overtime (Hours)</td>
          <td>{{DataList_Salary['ezakekarCount']|number}}</td>

          <td>Child Allowance</td>
          <td>{{DataList_Salary['tedadFarzand'] * DataList_Salary['salaryRecord']['farzand'] |number}}</td>

          <td colspan="2"></td>
        </tr>

        <tr>
          <td>Marital Status</td>
          <td>{{calcTahahol(DataList_Salary)}}</td>

          <td>Food Allowance</td>
          <td>{{DataList_Salary['salaryRecord']['kharbar']|number}}</td>

          <td colspan="2"></td>
        </tr>

        <tr>
          <td>Number of Children</td>
          <td>{{DataList_Salary['tedadFarzand']|number}}</td>

          <td>Behfa Membership Fee</td>
          <td>{{DataList_Salary['haghOzviyat']|number}}</td>

          <td style="background-color: rgb(181 184 187)">Total Deductions</td>
          <td>{{(calcKosorat(DataList_Salary))|number}}</td>
        </tr>

        <tr>
          <td>Work Shift</td>
          <td>{{DataList_Salary['salaryRecord_Person']['shift']|number}}</td>

          <td>Employee Allowance</td>
          <td>{{DataList_Salary['person']|number}}</td>

          <td colspan="2"></td>
        </tr>

        <tr>
          <td>Internal Mission Count</td>
          <td>{{DataList_Salary['missionCount']|number}}</td>

          <td>Job Allowance</td>
          <td>{{DataList_Salary['position']|number}}</td>

          <td colspan="2"></td>
        </tr>

        <tr>
          <td>External Mission Count</td>
          <td></td>

          <td>Performance Allowance</td>
          <td>{{DataList_Salary['performance']|number}}</td>

          <td colspan="2"></td>
        </tr>

        <tr>
          <td colspan="2"></td>

          <td>Overtime Pay</td>
          <td>{{DataList_Salary['ezakekar']|number}}</td>

          <td colspan="2"></td>
        </tr>

        <tr>
          <td colspan="2"></td>

          <td>Mission Allowance</td>
          <td>{{DataList_Salary['mission']|number}}</td>

          <td colspan="2"></td>
        </tr>

        <tr>
          <td colspan="2"></td>

          <td>Shift Allowance</td>
          <td>0</td>

          <td colspan="2"></td>
        </tr>

        <tr>
          <td colspan="2"></td>

          <td>Transportation Expense</td>
          <td>{{DataList_Salary['ayabZohab']|number}}</td>

          <td colspan="2"></td>
        </tr>

        <tr>
          <td colspan="2"></td>

          <td>Hospitality Allowance </td>
          <td>{{DataList_Salary['paziraee']|number}}</td>

          <td colspan="2"></td>
        </tr>

        <tr>
          <th colspan="2"></th>
          <th style="background-color: rgb(181 184 187)">Gross Pay</th>
          <td style="background-color: rgb(181 184 187)">{{DataList_Salary['salary2']|number}}</td>
          <th style="background-color: rgb(181 184 187)">Net Pay</th>
          <td style="background-color: rgb(181 184 187)">{{(DataList_Salary['salary2'] -
            calcKosorat(DataList_Salary))|number}}</td>
        </tr>

      </table>
    </div>

  </div>
</div>